import(/* webpackMode: "eager" */ "/work/src/src/app/page.tsx");
